import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
export function IsForYou() {
  return <div className="bg-sage-light/20" data-id="element-112">
      <Section className="max-w-3xl" data-id="element-113">
        <SectionTitle data-id="element-114">Esta guía es para vos si…</SectionTitle>

        <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-beige-muted/50 mt-8" data-id="element-115">
          <div className="space-y-5" data-id="element-116">
            {['Querés estimular a tu bebé sin estrés', 'No sabés qué actividades hacer', 'Buscás menos pantallas', 'Querés acompañar su desarrollo desde casa', 'Tenés poco tiempo', 'Querés sentir más conexión y tranquilidad'].map((item, i) => <div key={i} className="flex items-start gap-4" data-id="element-117">
                <CheckCircle2 className="w-6 h-6 text-cta flex-shrink-0 mt-0.5" data-id="element-118" />
                <p className="text-lg text-charcoal font-medium" data-id="element-119">{item}</p>
              </div>)}
          </div>
        </div>
      </Section>
    </div>;
}